/** Calendar dates are local date parts, never UTC timestamps. */
export function parseCalendarDate(value?: string | null): Date | undefined {
  if (!value || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return undefined;
  const [year, month, day] = value.split('-').map(Number);
  if (!year || !month || !day || year > 9999) return undefined;
  const date = new Date(0);
  date.setFullYear(year, month - 1, day);
  date.setHours(12, 0, 0, 0);
  return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day
    ? date
    : undefined;
}

export function calendarDateISO(date: Date): string {
  return `${String(date.getFullYear()).padStart(4, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

export function parseCalendarEntry(text: string): string | undefined {
  const value = text.trim();
  const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(value);
  const iso = match ? `${match[3]}-${match[2]}-${match[1]}` : value;
  return parseCalendarDate(iso) ? iso : undefined;
}

export function calendarDateAllowed(value: string, min?: string, max?: string): boolean {
  return (
    !!parseCalendarDate(value) &&
    (!parseCalendarDate(min) || value >= min!) &&
    (!parseCalendarDate(max) || value <= max!)
  );
}

export function calendarMonth(date: Date, offset = 0): Date {
  const result = new Date(date);
  result.setDate(1);
  result.setMonth(result.getMonth() + offset);
  return result;
}

export function calendarMonthDays(month: Date, fixedWeeks = true): Date[] {
  const first = calendarMonth(month);
  const last = calendarMonth(month, 1);
  last.setDate(0);
  const dayCount = fixedWeeks ? 42 : Math.ceil((first.getDay() + last.getDate()) / 7) * 7;
  first.setDate(first.getDate() - first.getDay());
  return Array.from({ length: dayCount }, (_, index) => {
    const day = new Date(first);
    day.setDate(first.getDate() + index);
    return day;
  });
}
